import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';
import { Dropdown, Input, Menu } from 'antd';
import { CaretDownOutlined, SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import { AppImage } from '../../shared';
import ModalAddCompany from './modal-add-company/modal-add-company';

import styles from './company.module.scss';

const Company = ({ toggleCollapsed }) => {
  const router = useRouter();
  const companies = useSelector((state) => state.user.companies);
  const company = useSelector((state) => state.user.company);

  const [addCompanyOpen, setAddCompanyOpen] = useState(false);
  const [companyList, setCompanyList] = useState(companies);

  const toggleAddCompanyOpen = () => setAddCompanyOpen(!addCompanyOpen);

  useEffect(() => {
    if (window.jivo_api) {
      window.jivo_api.setCustomData([
        {
          title: 'Авторизован',
          content: 'Да',
        },
        {
          title: 'ИНН',
          content: company.inn,
        },
      ]);
      window.jivo_api.setContactInfo({
        name: company.name,
        email: company.email,
        phone: company.phone,
      });
    }
  }, [company]);

  useEffect(() => {
    if (companies && companies.length) {
      setCompanyList(companies);
    }
  }, [companies]);

  const changeCompany = (e) => {
    localStorage.setItem('id', e.key);
    Cookies.remove('payoutTerminal');
    router.reload();
  };

  const getCompanyList = (evt) => {
    const str = evt.nativeEvent.target.value;

    if (str) {
      setCompanyList(
        companies.filter(
          (item) => item.name?.toLowerCase().includes(str)
            || item.legalName?.toLowerCase().includes(str)
            || item.inn?.toLowerCase().includes(str),
        ),
      );
    } else {
      setCompanyList(companies);
    }
  };

  const menu = (
    <div className={styles.company__dropdown}>
      <div className={styles.company__search}>
        <Input
          allowClear
          placeholder="Введите строку поиска"
          prefix=<SearchOutlined />
          onChange={(evt) => getCompanyList(evt)}
        />
      </div>
      <Menu
        className={`${styles.company__menu} ${styles['company__menu--scroll']}`}
      >
        {companyList.map((item) => (
          <Menu.Item
            key={item.id}
            icon={(
              <AppImage
                src={
                  item.logo
                    ? item.logo
                    : 'https://hb.bizmrg.com/invoice-media/default/merchant_logo.png'
                }
                alt="Логотип компании"
                width={24}
                height={24}
              />
            )}
            className={styles.company__item}
            onClick={(e) => changeCompany(e)}
          >
            <p>{item.name}</p>
            <p>{item.legalName}</p>
          </Menu.Item>
        ))}
      </Menu>
      <Menu className={styles.company__menu}>
        <Menu.Item
          key="new"
          className={`${styles.company__item} ${styles['company__item--new']}`}
          onClick={() => {
            if (toggleCollapsed) {
              toggleCollapsed();
            }
            toggleAddCompanyOpen();
          }}
        >
          Добавить организацию
        </Menu.Item>
      </Menu>
    </div>
  );

  return (
    <div className={styles.company}>
      {/* Logo */}
      <div className={styles.company__logo}>
        {company.dirlogo ? (
          <AppImage src={company.dirlogo} alt="Логотип" width="40" height="40" />
        ) : null}
      </div>

      {/* Info */}
      <Dropdown overlay={menu} trigger={['click']}>
        <button type="button" className="ant-dropdown-link btn-link">
          <div className={styles.company__wrap}>
            <div>
              <p className={styles.company__name}>{company.name}</p>
              <p className={styles.company__legaly}>{company.legalName}</p>
              <p className={styles.company__inn}>{company.inn}</p>
            </div>
            <CaretDownOutlined />
          </div>
        </button>
      </Dropdown>

      <ModalAddCompany
        isOpen={addCompanyOpen}
        onSuccess={toggleAddCompanyOpen}
        onCancel={toggleAddCompanyOpen}
      />
    </div>
  );
};

Company.propTypes = {
  toggleCollapsed: PropTypes.func,
};

Company.defaultProps = {
  toggleCollapsed: null,
};

export default Company;
